import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { LocalStorageService } from "@/modules/storage";
import { get, post } from "api";
import { PersonalisationWelcomeScreen } from "modules/personalisation/components/PersonalisationWelcomeScreen";

export const PersonalisationWelcomeContainer_PATH =
  "/personalise/welcome" as const;

export const PersonalisationWelcomeContainer = () => {
  const navigate = useNavigate();

  const { data: user } = useQuery({
    queryKey: ["/user"],
    queryFn: () => get("/user"),
  });

  const { data: platform } = useQuery({
    queryKey: ["/platform"],
    queryFn: () => get("/platform"),
  });

  const handleGetStarted = () => {
    // Check if user completed onboarding as part of gift card claim flow
    const isGiftCardClaim =
      LocalStorageService.getItem("isGiftCardClaim") === "true";

    if (isGiftCardClaim) {
      // Clean up gift card claim flags
      LocalStorageService.removeItem("isGiftCardClaim");
      LocalStorageService.removeItem("giftCardRecipientPhone");
      LocalStorageService.removeItem("giftCardRecipientPlatformUserId");
      LocalStorageService.removeItem("giftCardImageUrl");
      LocalStorageService.removeItem("giftCardAmount");
    }

    LocalStorageService.removeItem("referralCode");
    LocalStorageService.removeItem("referralSenderName");

    navigate("/home?fromPersonalisation=true");
  };

  const { mutate: recordReferralSignupCompleted } = useMutation({
    mutationFn: (statelessCode: string) =>
      post("/incentives/record-referral-signup-completed", {
        statelessCode: statelessCode,
        personId: user?.id as string,
        platformId: user?.platform?.id as string,
        platformLocationId: user?.platformLocation?.id as string,
      }),
    onSuccess: () => {
      console.log("Referral signup completed");
    },
  });

  useEffect(() => {
    const statelessCode = LocalStorageService.getItem("statelessReferralCode");

    if (
      statelessCode &&
      user?.id &&
      platform?.id &&
      user?.platformLocation?.id
    ) {
      recordReferralSignupCompleted(statelessCode);
    }
  }, [user, platform, recordReferralSignupCompleted]);

  return (
    <PersonalisationWelcomeScreen
      platformName={platform?.name || ""}
      platformLogoUrl={platform?.logoImageUrl || ""}
      userFirstName={user?.firstName || ""}
      onGetStarted={handleGetStarted}
    />
  );
};
